export function EmailIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M4.16675 3.33337H15.8334C17.2141 3.33337 18.3334 4.45266 18.3334 5.83337V14.1667C18.3334 15.5474 17.2141 16.6667 15.8334 16.6667H4.16675C2.78604 16.6667 1.66675 15.5474 1.66675 14.1667V5.83337C1.66675 4.45266 2.78604 3.33337 4.16675 3.33337ZM3.33341 6.14232V13.8215L7.29688 9.85807L3.33341 6.14232ZM4.51193 15H15.4882L11.4736 10.9854C10.5979 11.6255 9.40226 11.6255 8.5266 10.9854L4.51193 15ZM16.6667 13.8215V6.14232L12.7033 9.85807L16.6667 13.8215ZM15.4483 5.00004H4.55184L9.43013 9.57344C9.75068 9.87395 10.2495 9.87395 10.57 9.57344L15.4483 5.00004Z"
        fill="currentColor"
        fillOpacity="0.54"
      />
    </svg>
  );
}
